import { ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind.config.js가 spacing 값을 '48px' 같은 px 문자열 키로 등록해 두었는데, tailwind-merge는
 * 이 표기를 길이 값으로 인정하지 않는다. 그래서 알려주지 않으면 `my-48px`와 `my-0`을 서로 다른
 * 속성으로 보고 둘 다 남기고, 어느 쪽이 화면에 적용되는지는 컴파일된 CSS의 순서가 정한다.
 * margin, padding, width, height, gap, inset, space, translate가 모두 spacing을 참조한다.
 */
const isPxThemeValue = (value: string) => /^\d+(\.\d+)?px$/.test(value);

const twMerge = extendTailwindMerge({
  extend: {
    // config에서 px 문자열 키를 쓰는 스케일 전부. 하나라도 빠지면 그 유틸은 병합되지 않는다.
    theme: {
      spacing: [isPxThemeValue],
      borderRadius: [isPxThemeValue],
      borderWidth: [isPxThemeValue],
    },
    /**
     * fontSize도 '18px' 같은 키를 쓰지만 글자 크기 그룹은 theme을 참조하지 않고 자기 목록만 본다.
     * 알려주지 않으면 `text-18px`가 글자색으로 분류돼, 뒤에 오는 색 클래스에 크기가 지워진다.
     */
    classGroups: { 'font-size': [{ text: [isPxThemeValue] }] },
  },
});

/**
 * @link https://velog.io/@qwzx16/tailwind를-이용한-효율적인-React-Component-관리tailwind-merge-cva-clsx-파헤치기
 */
export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs));
};
